import React from 'react';
import { ErrorText as Error } from './styles';

export const ErrorText = ({ message, color, style = {} }, props) => {
    return (
        <Error color={color} style={style} {...props}>
            {message}
        </Error>
    );
};
